/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_ExpandInputs */



/**
* | output |
* | --- |
* | "Full screen" |
*
* @param {Chat_ExpandInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_expand = /** @type {((inputs?: Chat_ExpandInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_ExpandInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Volledig scherm")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plein écran")
	return /** @type {LocalizedString} */ ("Full screen")
});